module.exports = __webpack_public_path__ + "static/opener-text-sml-e39bbf2ce21609670c90612fd73125ce.png";